import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";

import styled from "styled-components";
import TextF6 from "../TextF6";
import TextF8 from "../TextF8";
import Box from "../Box";
import { themeGet } from "styled-system";
import { SmallContainer } from "../Grid";
import SubmitButton from "../SubmitButton";

const Answer = styled(TextF8)`
  font-weight: normal;
  margin: 2rem 0 0;
  padding: 4px 16px;
  border-left: 4px solid
    ${props => (props.correctAnswer ? "#19CA94" : "#E02C00")};
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;
const TextF6Regular = styled(TextF6)`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  font-weight: normal;
`;

const Input = styled.input`
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  color: 29264c;
  width: 100%;
  margin-top: 0;
  padding: 1.3rem 2rem;
  font-size: 1rem;
  border: 1px solid rgba(72, 68, 163, 1);
  border-radius: 8px;
  margin-bottom: 2rem;
  background-clip: padding-box;
`;

class Widget extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      quiz,
      answer,
      submitted,
      submitting,
      messages,
      onChange,
      onSubmit
    } = this.props;

    if (!quiz || (!!quiz && !quiz.data)) {
      return null;
    }

    return (
      <div>
        <Box bg="#EBE9EF" py={5}>
          <SmallContainer>
            {submitted && !!messages ? (
              <div>
                <TextF6 m={0}>
                  <FormattedMessage id="quiz.youAnswered" />
                </TextF6>
                <TextF6Regular m={0}>{answer}</TextF6Regular>
                <Answer
                  correctAnswer={!messages.error}
                  key={`message-${quiz.id}`}
                >
                  {messages.message}
                </Answer>
              </div>
            ) : (
              <Box>
                <Input
                  type="text"
                  value={answer}
                  onChange={e => onChange(e)}
                  placeholder={this.props.intl.formatMessage({
                    id: "quiz.yourAnswer"
                  })}
                />
                <Box display="flex" alignItems="center" justifyContent="center">
                  <SubmitButton
                    onSubmit={() => onSubmit()}
                    submitted={submitted}
                    submitting={submitting}
                    disabled={answer === ""}
                  />
                </Box>
              </Box>
            )}
          </SmallContainer>
        </Box>
      </div>
    );
  }
}

export default injectIntl(Widget);
